import React from 'react';
import Pages from 'pages';

function App() {
  return (
    <>
    {/* here can add header, sidebar, ... or any layouts required through the app */}
      <Pages />
    </>
  );
}

export default App;
